import React, { useState } from 'react';
import { CalendarPlus, Download, ArrowUpRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '../components/ui/popover';
import { useI18n } from '../i18n/I18nProvider';
import { addToCalendar, googleCalUrl } from '../lib/calendar';

export default function AddToCalendar({ event, variant = 'light', label }) {
  const { lang } = useI18n();
  const [open, setOpen] = useState(false);
  if (!event) return null;

  const dark = variant === 'dark';
  const btnClass = dark
    ? 'bg-[#d4a63d] hover:bg-[#b88a2a] text-[#1f3a2a]'
    : 'bg-[#1f3a2a] hover:bg-[#2e5340] text-[#f5efe3]';

  const t = {
    label: label || (lang === 'es' ? 'Agregar al calendario' : 'Add to calendar'),
    apple: lang === 'es' ? 'Apple Calendar · iOS' : 'Apple Calendar · iOS',
    google: lang === 'es' ? 'Google Calendar' : 'Google Calendar',
    ics: lang === 'es' ? 'Descargar .ics (Outlook)' : 'Download .ics (Outlook)',
    sub: lang === 'es' ? 'Elige tu calendario' : 'Pick your calendar',
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          className={`rounded-full h-11 px-5 inline-flex items-center gap-2 font-medium ${btnClass}`}
        >
          <CalendarPlus size={17} /> {t.label}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-72 bg-white border-[#e5dcc5] rounded-2xl p-3 shadow-[0_20px_50px_-20px_rgba(31,58,42,0.3)]">
        <p className="px-2 py-1.5 text-[10px] uppercase tracking-wider-xtra text-[#8a7a4e]">{t.sub}</p>
        <button
          onClick={() => { addToCalendar(event); setOpen(false); }}
          className="w-full flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm text-[#1f3a2a] hover:bg-[#faf6ea] transition-colors text-left"
        >
          <Download size={16} className="text-[#2e5340]" />
          <span className="flex-1">{t.apple}</span>
        </button>
        <a
          href={googleCalUrl(event)}
          target="_blank"
          rel="noreferrer"
          onClick={() => setOpen(false)}
          className="w-full flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm text-[#1f3a2a] hover:bg-[#faf6ea] transition-colors"
        >
          <ArrowUpRight size={16} className="text-[#2e5340]" />
          <span className="flex-1">{t.google}</span>
        </a>
        <button
          onClick={() => { addToCalendar(event); setOpen(false); }}
          className="w-full flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm text-[#1f3a2a] hover:bg-[#faf6ea] transition-colors text-left"
        >
          <Download size={16} className="text-[#2e5340]" />
          <span className="flex-1">{t.ics}</span>
        </button>
      </PopoverContent>
    </Popover>
  );
}
